<template>
  <div class="bucket-actions-table-cell">
    <v-menu
        bottom
        right
        offset-x
        :close-on-content-click='true'
        :nudge-width="100"
        rounded
        :disabled='!bucketActions.length'
    >
      <template v-slot:activator="{ on, attrs }">
        <div
            v-bind="attrs"
            v-on="on"
            id='more'
            class='material-icons-outlined more-btn'
        >
          more_vert
        </div>
      </template>

      <v-list>
        <v-list-item
            v-for="(action, i) in bucketActions"
            :key="i"
            link
            @click='initiateActionFromMenu(action.value)'
            class="menu-item"
        >
          <v-list-item-title>{{ action.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import {CONFIGURATION} from '@/constants/configuration';

export default {
  name: 'ActionsTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async initiateActionFromMenu(action) {
      await this.$emit('initiateAction', { action, item: this.item });
    },
  },
  computed: {
    bucketActions() {
      let actions = Object.keys(CONFIGURATION.BUCKET_ACTIONS_TYPES).map(item => ({ value: item, title: this.$t(`cloud.assets.action.${item}`) }));
      if (this.item.suppress) {
        actions = actions.filter(action => action.value === CONFIGURATION.BUCKET_ACTIONS_TYPES.unsuppressed);
      } else {
        actions = actions.filter(action => action.value === CONFIGURATION.BUCKET_ACTIONS_TYPES.suppress);
      }
      return actions;
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.bucket-actions {
  min-width: 27px !important;
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.menu-item {
  min-height: 30px;
  padding-left: 18px !important;
  width: fit-content;
  .v-list-item__title {
    font-family: $font-family-medium !important;
    font-size: $font-size-base !important;
  }
}
.more-btn {
  opacity: 0;
  color: var(--text-disabled);
  &:hover {
    cursor: pointer;
    opacity: 1;
  }
}
.bucket-actions-table-cell {
  align-items: center;
  display: flex;

  .run-config-action-btn {
    font-family: $font-family-medium;
    font-size: $font-size-sm;
    height: 28px;
    width: 153px;
    border-radius: $radius-sm;
    color: white;
    box-shadow: $shadow-sm;
  }

  .v-list-item {
    min-height: 30px;
    padding-left: 18px !important;
    width: fit-content;
  }

  .v-list-item__title {
    font-family: $font-family-medium !important;
    font-size: $font-size-base !important;
  }
}
</style>
